module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attach"
  }, [(!_vm.dataOnlyMode) ? _c('div', {
    staticClass: "attach__content"
  }, [(_vm.stream_assoc.value) ? [(_vm.stream_assoc.type == 'Album') ? _c('attach-card', {
    attrs: {
      "image": _vm._.get(_vm.stream_assoc.value, 'cover.thumb.url', ''),
      "title": _vm.stream_assoc.value.name,
      "subtitle": ((_vm.stream_assoc.value.tracks.length) + " tracks")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stream_assoc.type == 'ShopProduct') ? _c('attach-card', {
    attrs: {
      "image": _vm._.get(_vm.stream_assoc.value, 'covers[0].cover.thumb.url', ''),
      "title": _vm.stream_assoc.value.name,
      "subtitle": ("$" + (_vm.$options.filters.formatNumber(
          _vm.stream_assoc.value.price
        )))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stream_assoc.type == 'User') ? _c('attach-card', {
    attrs: {
      "image": _vm._.get(_vm.stream_assoc.value, 'avatar.thumb.url', ''),
      "title": _vm.stream_assoc.value.username,
      "subtitle": ((_vm.stream_assoc.value.followers) + " followers")
    }
  }) : _vm._e()] : [_c('div', {
    staticClass: "attach__image"
  })]], 2) : _vm._e(), _vm._v(" "), (!_vm.hideMetaActions) ? _c('div', {
    staticClass: "attach__footer"
  }, [(_vm.stream_assoc.value) ? [_c('span', {
    staticClass: "attach__cta",
    on: {
      "click": function($event) {
        _vm.openAttachPicker()
      }
    }
  }, [_vm._v("Change")]), _vm._v(" "), (!_vm.dataOnlyMode) ? _c('span', {
    staticClass: "attach__cta danger",
    on: {
      "click": function($event) {
        _vm.removeAttach()
      }
    }
  }, [_vm._v("Remove")]) : _vm._e()] : [_c('span', {
    staticClass: "attach__cta",
    on: {
      "click": function($event) {
        _vm.openAttachPicker()
      }
    }
  }, [_vm._v(_vm._s(_vm.ctaTitle))])]], 2) : _vm._e(), _vm._v(" "), (_vm.show_attach_picker) ? _c('attach-picker', {
    attrs: {
      "dismiss": _vm.closeAttachPicker,
      "title": _vm.attachPickerTitle,
      "customAlbums": _vm.customAlbums,
      "customProducts": _vm.customProducts,
      "fullscreen": _vm.fullscreen
    },
    on: {
      "getSelected": _vm.getSelected
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dd9ae6f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/video/components/attach.vue
// module id = 1637
// module chunks = 180